// Topbar module - universal custom search logic for both Topbar and Navbar search
export default class Topbar {
  constructor(element) {
    this.element = element;
    // Find all search forms supported by this module (both topbar and navbar styles)
    this.searchForms = Array.from(
      element.querySelectorAll('.topbar__search-form, .navbar__search-form')
    );

    // For each form, gather references to its input, clear button, wrapper, text (if present)
    this.searchControls = this.searchForms.map(form => {
      return {
        form,
        input: form.querySelector('.topbar__search-input, .navbar__search-input'),
        wrapper: form.querySelector('.topbar__search-wrapper, .navbar__search-wrapper'),
        text: form.querySelector('.topbar__search-text, .navbar__search-text'),
        clear: form.querySelector('.topbar__search-clear, .navbar__search-clear')
      };
    });

    this.init();
  }

  init() {
    this.searchControls.forEach(controls => {
      const { form, input, wrapper, text, clear } = controls;

      // Search wrapper click - activate search input
      if (wrapper && input) {
        wrapper.addEventListener('click', () => {
          this.activateSearch(input, text);
        });

        // Search input blur - deactivate if empty
        input.addEventListener('blur', () => {
          if (!input.value.trim()) {
            this.deactivateSearch(input, text);
          }
        });

        // Search form submit
        if (form) {
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleSearch(input);
          });
        }
      }

      // Search input change - show/hide clear button
      if (input) {
        input.addEventListener('input', (e) => {
          this.toggleClearButton(input, clear);
          const query = e.target.value.trim();
          if (query.length > 2) {
            // Here you can add autocomplete
            // this.suggestSearch(query);
          }
        });

        // Check at page load
        this.toggleClearButton(input, clear);
      }

      // Clear button click
      if (clear && input) {
        clear.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.clearSearch(input, clear);
        });
      }
    });

    // Rotate dropdown icon on toggle (Bootstrap handles dropdown functionality)
    const dropdownToggle = this.element.querySelector('#userDropdown');
    if (dropdownToggle) {
      dropdownToggle.addEventListener('shown.bs.dropdown', () => {
        const icon = dropdownToggle.querySelector('.topbar__dropdown-icon');
        if (icon) {
          icon.style.transform = 'rotate(180deg)';
        }
      });

      dropdownToggle.addEventListener('hidden.bs.dropdown', () => {
        const icon = dropdownToggle.querySelector('.topbar__dropdown-icon');
        if (icon) {
          icon.style.transform = 'rotate(0deg)';
        }
      });
    }
  }

  toggleClearButton(input, clear) {
    if (clear && input) {
      const hasValue = input.value.trim().length > 0;
      clear.style.display = hasValue ? 'flex' : 'none';
    }
  }

  clearSearch(input, clear) {
    if (input) {
      input.value = '';
      input.focus();
      this.toggleClearButton(input, clear);
    }
  }

  activateSearch(input, text) {
    if (input) {
      input.style.opacity = '1';
      input.focus();
    }
    if (text) {
      text.style.opacity = '0';
    }
  }

  deactivateSearch(input, text) {
    if (input) {
      input.style.opacity = '0';
    }
    if (text) {
      text.style.opacity = '1';
    }
  }

  handleSearch(input) {
    const query = input.value.trim();
    if (query) {
      // Search logic will be handled by backend
      console.log('Search:', query);
      // Can add redirect to search page
      // window.location.href = `/search?q=${encodeURIComponent(query)}`;
    }
  }
}
